// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(axios)
// Vue.use(VueAxios)
import axios from '@/plugins/axios'

export default {
  install(Vue) {
    Vue.prototype.$deliveryAreaApiService = {
      delivery_area_api_url: `${process.env.VUE_APP_DELIVERY_API_URL}/delivery-areas`,

      /**
       * 查詢
       * @param {string} param - 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async query(param = '') {
        const url = `${this.delivery_area_api_url}`
        const params = param ? `?${param}` : ''
        const response = await axios.get(`${url}${params}`)
        return response.data
      },

      /**
       * 透過英文名稱取得
       * @param {*} english_name 
       * @param {*} additional 
       * @returns 
       */
      async getByEnglishName(english_name, additional = '') {
        const url = `${this.delivery_area_api_url}?filter[english_name]=${english_name}`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)

        return response.data.data && response.data.data.length > 0
          ? { data: response.data.data[0] }
          : null
      },

      /**
       * 透過 ID 取得
       * @param {*} id 
       * @param {*} additional 
       * @returns 
       */
      async getById(id, additional = '') {
        const url = `${this.delivery_area_api_url}/${id}`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)

        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data
          : null
      }
    }
  }
}
